// arquivo temporario para centralizar melhor dados até criarmos um serviço para isso

export const idleTimeoutConfig = {
  timeToCancelCountDown : 60,
  idle: 600,
  timeout: 1,
   ping: 5000
} as const
